/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_No_Samples_SelectedInputs */

const en_samples_no_samples_selected = /** @type {(inputs: Samples_No_Samples_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No samples selected`)
};

const es_samples_no_samples_selected = /** @type {(inputs: Samples_No_Samples_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay muestras seleccionadas`)
};

/**
* | output |
* | --- |
* | "No samples selected" |
*
* @param {Samples_No_Samples_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_no_samples_selected = /** @type {((inputs?: Samples_No_Samples_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_No_Samples_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_no_samples_selected(inputs)
	return es_samples_no_samples_selected(inputs)
});